<template>
    <div class="camere-selector-item">
        <div class="d-flex justify-content-between mb-2">
            <h4>{{title}}</h4>
        </div>
        <div class="d-flex justify-content-between mb-2">
            <div>
                <span>Adulti</span>
                <small>almeno 18 anni</small>
            </div>
            <div>
                <InputIncrement :value=info.adults :min=1 @change="onAdultChange" :disabled="disabled" />
            </div>
        </div>
        <div class="d-flex justify-content-between mb-2">
            <div>
                <span>Bambini</span>
                <small>meno di 18 anni</small>
            </div>
            <div>
                <InputIncrement :value=info.childs.length @change="onChildChange" :disabled="disabled" />
            </div>
        </div>
        <div v-if="info.childs.length > 0">
            <span>età dei bambini <small>(anni compiuti)</small></span>
            <div class="ages row no-gutters pt-2">
                <div class="col-4 mb-1" v-for="(child, index) in info.childs" :key="index" :value="child">
                    <select class="form-control" :index="index" @change="onEtaChange">
                        <option v-for="item in eta" :key="item" :value="item" :selected="item === child.eta">
                            {{item}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {clone} from '../../../../utils/helper'
import InputIncrement from '../InputIncrement'

export default {
  name: 'CamereSelectorItem',
  components: {InputIncrement},
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {
        return {adults: 0, childs: []}
      }
    },
    index: Number
  },
  data: function () {
    return {
      eta: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      info: {
        index: this.index,
        adults: this.value.adults,
        childs: this.value.childs
      }
    }
  },
  computed: {
    disabled: function () {
      return this.info.adults + this.info.childs.length === 4
    }
  },
  methods: {
    onAdultChange (numAdults) {
      this.info.adults = numAdults
      this.$emit('change', this.payload())
    },
    onChildChange (numChildren) {
      if (this.info.childs.length < numChildren) {
        this.info.childs.push(0)
      } else {
        this.info.childs.pop()
      }
      this.$emit('change', this.payload())
    },
    onEtaChange (event) {
      const index = 1 * event.target.getAttribute('index')
      this.info.childs[index] = 1 * event.target.value
      this.$emit('change', this.payload())
    },
    payload: function () {
      return clone(this.info)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/camere-selector/CamereSelectorItem.vue